// extracted by mini-css-extract-plugin
module.exports = {"container":"addPeriodObserver_container__25J0t"};
    if(module.hot) {
      // 1783592058646
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  